import styled from "styled-components";
import { DEFAULT_ANIMATION_SPEED } from "../../constants";
import { colorMixin, typographyMixin } from "../../helpers";

export const Container = styled.button`
    --card-select-border-color: ${colorMixin("primary-100")};
    --card-select-background-color: ${colorMixin("surface-base")};
    --card-select-primary-text-color: ${colorMixin("primary-1200")};
    --card-select-secondary-text-color: ${colorMixin("primary-700")};
    --card-select-padding: 12px 16px;
    cursor: pointer;

    &:hover:not(:disabled):not([data-active="true"]) {
        --card-select-border-color: ${colorMixin("primary-300")};
        --card-select-background-color: ${colorMixin("surface-25")};
    }

    &[data-active="true"] {
        --card-select-border-color: ${colorMixin("primary-1200")};
        --card-select-background-color: ${colorMixin("surface-base")};
    }

    &:disabled {
        --card-select-border-color: ${colorMixin("primary-100")};
        --card-select-background-color: ${colorMixin("surface-50")};
        --card-select-primary-text-color: ${colorMixin("primary-500")};
        --card-select-secondary-text-color: ${colorMixin("primary-300")};
        cursor: not-allowed;
    }

    width: 100%;
    position: relative;
    text-align: left;

    display: flex;
    align-items: center;
    gap: 8px;
    padding: var(--card-select-padding);

    background-color: var(--card-select-background-color);
    border: 1px solid var(--card-select-border-color);
    border-radius: 4px;
    transition: all ease-in-out ${DEFAULT_ANIMATION_SPEED}ms;
`;

export const PrimaryText = styled.div`
    ${typographyMixin("label-small-medium")};

    color: var(--card-select-primary-text-color);
`;

export const SecondaryText = styled.div`
    ${typographyMixin("label-x-small-regular")};

    color: var(--card-select-secondary-text-color);
`;
